import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  colorsSchema: null,
  // Altri stati UI globali possono essere aggiunti qui
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setColorsSchema: (state, action) => {
      state.colorsSchema = action.payload;
    },
    clearUiData: (state) => {
      return initialState;
    }
  },
});

export const { setColorsSchema, clearUiData } = uiSlice.actions;

export const selectColorsSchema = (state) => state.ui.colorsSchema;

export default uiSlice.reducer;
